<template>
  <div class="dropdown" :class="{open:isOpen}" @click="toggleDropDown" v-click-outside="closeDropDown">
    <button class="btn btn-primary dropdown-toggle my-1" data-toggle="dropdown">
      <slot name="title">
        <i :class="icon"></i>
        {{title}}
       <span class="caret"></span>
      </slot>
    </button>
    <ul class="dropdown-menu" :class="{ 'drop-up': dropUp }">
      <slot name="menu">
        <template v-for="(action, i) in actions">
          <li :key="i" v-if="action.labelOnly">
            <span class="fa fa-fw" :class="action.icon"></span>
            {{ action.label }}
          </li>
          <li v-else :key="i" @click="$emit('action', action.command)" class="interactive-cursor">
            <span class="fa fa-fw" :class="action.icon"></span>
            {{ action.label }}
          </li>
          <div :key="i + 'divider'" class="dropdown-divider" v-if="i < actions.length - 1"></div>
        </template>
      </slot>
    </ul>
  </div>
</template>
<script>
  export default {
    props: {
      dropUp: {
        type: Boolean,
        default () {
          return true
        }
      },
      title: String,
      icon: String,
      actions: {
        type: Array
      }
    },
    data () {
      return {
        isOpen: false
      }
    },
    methods: {
      toggleDropDown () {
        this.isOpen = !this.isOpen
      },
      closeDropDown () {
        this.isOpen = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/Dropdown.vue